export default {
  REQUIRED: 'required',
  ON_ACTION: 'on_action',
  NO: 'no',
  VOLUNTARY: 'voluntary',
};
